import { render, staticRenderFns } from "./qzDetail.vue?vue&type=template&id=02fdd9b2&scoped=true"
import script from "./qzDetail.vue?vue&type=script&lang=js"
export * from "./qzDetail.vue?vue&type=script&lang=js"
import style0 from "./qzDetail.vue?vue&type=style&index=0&id=02fdd9b2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fdd9b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02fdd9b2')) {
      api.createRecord('02fdd9b2', component.options)
    } else {
      api.reload('02fdd9b2', component.options)
    }
    module.hot.accept("./qzDetail.vue?vue&type=template&id=02fdd9b2&scoped=true", function () {
      api.rerender('02fdd9b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cooperationMall/newCooperationMall/detail/qzDetail.vue"
export default component.exports